import React, { useEffect, useState } from 'react';
import { withRouter, Link, Route, useLocation } from 'react-router-dom';
import SendEmail from './SendEmail/SendEmail';
import SendText from './SendText/SendText';
import Archive from './Archive/Archive';
import arrowBack from "../../../../../../assets/arrow-back.svg";
import { config } from "../../../../../../config";
import axiosApi from './../../../../../../core/interceptor/interceptor';

function MessageContainer({ match, location, type }) {
    const [hideArchBtn, setHideArchBtn] = useState(false);
    const search = useLocation().search;
    const [hideBtn, setHideBtn] = useState(new URLSearchParams(search).get('hideBtn'));
    const [leagueId, setLeagueId] = useState(new URLSearchParams(search).get('leagueId'));
    const season_id = new URLSearchParams(search).get('season_id');
    const getLeagueAndSeasonInfo = () => {
        axiosApi.get(
            `${config.apiUrl}/misc/league/season/info/${leagueId}`
        ).then(
            (response) => {
                setSeasonLeagueInfo(response.data.data);
            }
        )
    }
    const [seasonLeagueInfo, setSeasonLeagueInfo] = useState([]);

    useEffect(() => {
        if (leagueId !== null) {
            getLeagueAndSeasonInfo();
        } else {
            if (location && location.state && location.state.leagueId) {
                setLeagueId(Number(location.state.leagueId));
            }
        }
        setHideBtn(new URLSearchParams(search).get('hideBtn'));
        //eslint-disable-next-line
    }, [])
    return <>
        <div className={`content-wrapper sendEmail-wrapper ${hideArchBtn && 'archive-wrapper'}`} >
            <div className="header">
                <div className="button-wrapper">
                    {!hideBtn || location?.pathname?.includes('/archive') ? <Link
                        onClick={() => hideArchBtn && setHideArchBtn(!hideArchBtn)}
                        to={hideArchBtn ? `${match.url}${hideBtn ? '?hideBtn=1' : ''}${leagueId !== null ? `?leagueId=${leagueId}${season_id ? `&season_id=${season_id}` : ''}` : ''}` : `${leagueId !== null ? `/admin/leagues/teams?leagueId=${leagueId}${season_id ? `&season_id=${season_id}` : ''}` : "/admin/users"}`}
                    >
                        <button className="back-btn"><img src={arrowBack} alt='back-arrow' /> Back to
                            {
                                hideArchBtn ? `${type === 'email' ? ' Email' : ' SMS'}`
                                    : ` ${leagueId !== null ? "League" : "Users"}`
                            }
                        </button>
                    </Link> : ''}
                    <Link
                        onClick={() => !hideArchBtn && setHideArchBtn(!hideArchBtn)}
                        to={`${match.url}/archive${leagueId !== null ? `?leagueId=${leagueId}${season_id ? `&season_id=${season_id}` : ''}` : ''}`}
                        hidden={hideArchBtn}
                    >
                        <button>{`${type === 'email' ? "View Archive" : "View SMS Reminder"}`}</button>
                    </Link>
                </div>
                <div className="header-blk">
                    <h2>
                        {
                            hideArchBtn ? `${type === 'email' ? "Email Archive" : "SMS"}`
                                : `Mass ${type === 'email' ? "Email" : "SMS Reminders"}`
                        }
                    </h2>
                    <p>
                        {
                            hideArchBtn ? 'Select a message to view details.'
                                : `Sending ${type === 'email' ? "email" : "SMS"} to ${leagueId !== null && seasonLeagueInfo ? `"${seasonLeagueInfo.season && seasonLeagueInfo.season.name} ${seasonLeagueInfo.name}"` : "all current users"}`
                        }
                    </p>
                </div>
            </div>
            <Route path={`${match.path}`} exact>
                {
                    (
                        () => {
                            if (type === 'email') {

                                return <SendEmail setArchieve={() => setHideArchBtn(v => !v)} />
                            }
                            return <SendText setArchieve={() => setHideArchBtn(v => !v)} />
                        }
                    )()
                }
            </Route>
            <Route path={`${match.path}/archive`}>
                <Archive type={type} hideArchBtn={(e) => setHideArchBtn(false)} />
            </Route>
        </div>
    </>
}

export default withRouter(MessageContainer);